module.exports = __webpack_public_path__ + "img/2.2f3d0751.png";